import React from 'react';
import { formatToUSD } from '../../network/helper';
 
const Cell = ({ children, className = '', height = 'h-6' }) => (
    <div className={`border-b border-r border-black flex items-center justify-center p-1 text-center text-xs ${height} ${className}`}>
        {children}
    </div>
);
 
const ExcelTable = ({name,color,selectedMonth,year,yearlydata,monthlydata,setMonthlydata,selectedYear,shortName}) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const rowNumbers = Array.from({ length: 31 }, (_, i) => i + 1);
 
    // console.log(yearlydata,"yearlydatayearlydata")

    const currentYear = yearlydata?.length > 0 ? yearlydata?.length == 1 ? yearlydata[0] : yearlydata[1] :  [];
    const lastYear = yearlydata?.length > 0 ? yearlydata?.length == 1 ? [] : yearlydata[0] : [];

    const formattoUSDoller = (data) => {
        if(data != undefined && data != '' && !data?.toString()?.includes('$')){
            return formatToUSD(data)
        }else{
           return data
        }
    }
    // console.log(monthlydata?.yearTotal,"monthlydatamonthlydata",monthlydata?.months?.[0]?.month)
    console.log(currentYear?.year ,"year",year,"currentYear12",lastYear.year == year-1,"lastYear")
    
    return (
        <div className="bg-black font-sans p-0.5">
            {/* Top Red Header */}
            <div className={`bg-black text-${color} font-bold text-center py-1 text-sm`}>
                {name}
            </div>
 
            <div className="bg-white border-t border-l border-black">
                {/* Header Row */}
                <div className="flex font-bold">
                    <div className="w-36 text-center border-b border-r border-black py-1">
                        {monthlydata?.months?.[0]?.month?.slice(0,3)} MTD</div>
                    <div className="flex-1 text-center border-b border-r border-black py-1">YTD {lastYear?.year || lastYear?.length == 0 ? year-1 : '' }</div>
                </div>
 
                <div className="flex">
                    {/* Column 1: Row Numbers */}
                    <div className="w-12">
                        {rowNumbers.map(num => (
                            <Cell key={num} className="font-bold text-dark-600">{num}</Cell>
                        ))}
                        <Cell className="w-36 h-20 bg-cyan-400 font-bold !text-[10px] text-start">MTD RUNNING TOTAL</Cell>
                        <Cell className="w-[144px] h-20 bg-gray-300 font-bold ps-2">
                        <input type="input" className="w-[135px] bg-gray-300" 
                        placeholder='$0'
                        value={formattoUSDoller(monthlydata?.yearTotal)} 
                        onChange={(e)=>{setMonthlydata((prev)=>{return{...prev, yearTotal: e.target.value}})}}
                        onBlur={(e) => {
                            const numeric = parseFloat(e.target.value.replace(/[^0-9.]/g, ''));
                            setMonthlydata((prev)=>{return{...prev, yearTotal: isNaN(numeric) ? '' : formatToUSD(numeric)}})
                        }}
                        />
                        </Cell>
                    </div>
                    <div className="w-24">
                        {monthlydata?.months?.length > 0 ? (monthlydata?.months[0]?.days?.length> 0 && monthlydata?.months[0]?.days?.map(num => (
                            <Cell key={num} className="font-bold text-dark-600">{formatToUSD(num?.total) || '-'}</Cell>
                        ))) : rowNumbers?.map(num => (
                            <Cell key={num} className="font-bold text-dark-600">-</Cell>
                        ))}

                    </div>
 
                    {/* Column 2: Months and Footer Labels */}
                    <div className="w-28">
                       
                        {months.map(month => (
                            <Cell key={`2023-${month}`} className={`font-bold bg-gray-300`}>
                                {month}
                            </Cell>
                        ))}
                        <Cell height="h-10" className="font-bold bg-gray-300 text-black flex-col">
                            Total YTD
                            <span className="font-bold text-black">{lastYear?.year}</span>
                        </Cell>
                        <Cell className="bg-black text-white font-bold">{currentYear?.year}</Cell>
                        {months.map(month => (
                            <Cell key={`2024-${month}`} className="font-bold bg-gray-300">{month}</Cell>
                        ))}
                         <Cell className="h-[120px] font-bold bg-black text-white flex-col">
                            TOTAL YTD <span className="font-normal text-gray-400">{currentYear?.year}</span>
                        </Cell>
                        <Cell className="h-20 bg-lime-400 font-bold">QB BALANCE</Cell>
                        <Cell className={`h-20 bg-yellow-300 font-bold ${shortName == 'TOTAL'  ? '!text-[10px]' : ''}`}>{name == "FEDERAL WAY PROF. PLAZA" ? '' : shortName == 'TOTAL' ? 'TOTAL AVAIL. CREDIT' : `${shortName} LOC AVAIL`}</Cell>
                    </div>
 
                    {/* Column 3: Data */}
                    <div className="flex-1 flex flex-col">
                        {/* 2023 Data */}
                        {Array.from({ length: 12 }).map((_, i) => <Cell key={`data-23-${i}`} >{lastYear?.months?.length > 0 ? formatToUSD(lastYear?.months[i].total) : '-'}</Cell>)}
                        <Cell height="h-10" className="font-bold flex justify-around items-center bg-gray-300 text-black">
                            <span>{formatToUSD(lastYear?.yearTotal)}</span>
                        </Cell>
 
                        {/* 2024 Header */}
                        <Cell className="bg-black text-white font-bold"></Cell>
                        {/* 2024 Data */}
                        {Array.from({ length: 12 }).map((_, i) => <Cell key={`data-24-${i}`}>{currentYear?.months?.length > 0 ? formatToUSD(currentYear?.months[i].total) : '-'}</Cell>)}
 
                         <Cell className="h-[120px] font-bold flex justify-around items-center bg-black text-white">
                            <span>{formatToUSD(currentYear?.yearTotal)}</span>
                        </Cell>
 
                        {/* Footer Data */}
                        <Cell className="h-20 bg-lime-400 font-bold">
                        <input type="input" className="w-[128px] bg-lime-400" 
                        placeholder='$0'
                        value={monthlydata?.qbBalance} 
                        onChange={(e)=>{setMonthlydata((prev)=>{return{...prev, qbBalance: e.target.value}})}}
                        onBlur={(e) => {
                            const numeric = parseFloat(e.target.value.replace(/[^0-9.]/g, ''));
                            setMonthlydata((prev)=>{return{...prev, qbBalance: isNaN(numeric) ? '' : formatToUSD(numeric)}})
                        }}
                        />
                        </Cell>
                        <Cell className="h-20 bg-yellow-300 font-bold">{name != "FEDERAL WAY PROF. PLAZA" &&<input type="input" className="w-[128px] bg-yellow-300" 
                        placeholder='$0'
                        value={monthlydata?.aolocAvail} 
                        onChange={(e)=>{setMonthlydata((prev)=>{return{...prev, aolocAvail: e.target.value}})}}
                        onBlur={(e) => {
                            const numeric = parseFloat(e.target.value.replace(/[^0-9.]/g, ''));
                            setMonthlydata((prev)=>{return{...prev, aolocAvail: isNaN(numeric) ? '' : formatToUSD(numeric)}})
                        }}
                        />}</Cell>
                    </div>
                </div>
            </div>
 
             {/* Bottom Red Header */}
             <div className={`bg-black text-${color} font-bold text-center py-1 text-sm`}>
                {name}
            </div>
        </div>
    );
};
 
export default ExcelTable;